module.exports = __webpack_public_path__ + "img/44.2d147909.webp";